import {
  prepareHostForModuleFederation,
  replaceEnvironmentFile,
} from '@paldesk/module-federation/utils';
import { environment } from './environments/environment';

replaceEnvironmentFile(
  environment.production
    ? 'assets/config/config.json'
    : 'assets/config/config.development.json',
  environment,
)
  .then(() =>
    prepareHostForModuleFederation({
      hostName: 'status-paldesk',
      env: environment.environment,
    }),
  )
  .then(() => import('./bootstrap'));
